import { SkeletonStyle } from './styled';

const Skeleton: React.FC = () => {
    return <SkeletonStyle></SkeletonStyle>;
};

export default Skeleton;
